var $ab4663858c47a151$exports = {};
/**
 * Copyright © RINIS 2026
 * Licensed under the EUPL
 */ $ab4663858c47a151$var$enableCopyOnClick();
document.body.addEventListener('htmx:afterSettle', function() {
    $ab4663858c47a151$var$enableCopyOnClick();
});
function $ab4663858c47a151$var$enableCopyOnClick() {
    document.querySelectorAll('[data-copy-on-click]').forEach((el)=>{
        // first remove the listener in case it was added in a previous HTML request
        el.removeEventListener('click', $ab4663858c47a151$var$onClickHandler);
        el.addEventListener('click', $ab4663858c47a151$var$onClickHandler);
    });
}
function $ab4663858c47a151$var$onClickHandler(event) {
    $ab4663858c47a151$var$copyTextFromElementToClipboard(event.currentTarget.dataset.copyOnClick);
    event.preventDefault();
}
function $ab4663858c47a151$var$copyTextFromElementToClipboard(elementID) {
    const text = document.getElementById(elementID).innerText.trim();
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(text);
    else {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "absolute";
        textArea.style.left = "-999999px";
        document.body.prepend(textArea);
        textArea.select();
        try {
            document.execCommand("copy");
        } catch (error) {
            console.error(error);
        } finally{
            textArea.remove();
        }
    }
}


//# sourceMappingURL=controller.536407e1.js.map
